// Events
import {
  MODAL_CLOSE,
  MODAL_OPEN,
  PRODUCT_FORM_UPDATE_VARIANT,
  PRODUCT_STICKY_FORM_HIDE,
  PRODUCT_STICKY_FORM_SHOW,
  STICKY_FOOTER_TOGGLE_SECTION,
} from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import formatMoney from 'utils/format-money';
import { hide, show } from 'utils/node';

export default component((node, ctx) => {
  const { sectionToggle, section, priceCurrent, priceOld, backToTopButton } = choozy(node);

  if (sectionToggle) {
    const sectionToggles = [].concat(sectionToggle);

    sectionToggles.forEach((button) => {
      button.addEventListener('click', () => {
        ctx.emit(STICKY_FOOTER_TOGGLE_SECTION, null, button.dataset.sectionToggle);
      });
    });
  }

  if (section) {
    const sections = [].concat(section);

    // Detect click outside
    window.addEventListener('click', (e) => {
      if (node.contains(e.target)) return;

      sections.forEach((s) => {
        s.classList.remove('open');
      });
    });

    ctx.on(STICKY_FOOTER_TOGGLE_SECTION, (state, sectionId) => {
      const targetSection = sections.find((s) => s.dataset.section === sectionId);

      if (targetSection) {
        targetSection.classList.toggle('open');

        if (targetSection.classList.contains('open')) {
          document.dispatchEvent(
            new CustomEvent('sticky-footer-section-closed', { detail: { section: sectionId } }),
          );
        }
      }
    });
  }

  const { modalId, productId, formId } = node.dataset;

  let openBackInStockOnShow = true;

  /** The back in stock modal should only be shown when the customer
   * clicks on an unavailable size inside the sticky footer, or an unavailable
   * variant is already selected on page load and the sticky footer is shown after
   * scroll restoration takes place. To prevent the modal from being shown when the
   * customer manually scrolls down there's this timeout */
  setTimeout(() => {
    openBackInStockOnShow = false;
  }, 1000);

  ctx.on(PRODUCT_STICKY_FORM_SHOW, ({ forms }) => {
    ctx.emit(MODAL_OPEN, null, { id: modalId });

    if (openBackInStockOnShow && productId in forms) {
      const { selectedVariant } = forms[productId];

      if (!selectedVariant.available) {
        ctx.emit(MODAL_OPEN, null, { id: 'back-in-stock-modal' });
      }
    }

    openBackInStockOnShow = false;
  });

  ctx.on(PRODUCT_STICKY_FORM_HIDE, () => {
    ctx.emit(MODAL_CLOSE, null, { id: modalId });
  });

  ctx.on(PRODUCT_FORM_UPDATE_VARIANT, (state, id) => {
    if (+productId !== id) return;

    const { selectedVariant } = state;

    if (!selectedVariant) return;

    const { price, compare_at_price: compareAtPrice } = selectedVariant;

    priceCurrent.textContent = formatMoney(price).removeTrailingZeros();
    priceOld.textContent = formatMoney(compareAtPrice).removeTrailingZeros();

    if (compareAtPrice && compareAtPrice > price) {
      show(priceOld);
    } else {
      hide(priceOld);
    }
  });

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  backToTopButton.addEventListener('click', scrollToTop);

  const handleUpdate = (e) => {
    const { currentProductId } = e.detail;
    const { forms, activeModals } = ctx.getState();
    const { selectedVariant } = forms[currentProductId];

    openBackInStockOnShow = false;

    if (!activeModals.includes(modalId)) return;

    if (selectedVariant.available) {
      ctx.emit(MODAL_CLOSE, null, { id: 'back-in-stock-modal' });
    } else {
      ctx.emit(MODAL_OPEN, null, { id: 'back-in-stock-modal' });
    }
  };

  document.addEventListener(`${productId}:${formId}:update`, handleUpdate);

  document.addEventListener(
    `${productId}:${formId}:unmount`,
    () => {
      document.removeEventListener(`${productId}:${formId}:update`, handleUpdate);
    },
    { once: true },
  );
});
